import React from "react";
import RenderPart from "../../RenderPart";

const List = ({ items }) => {
	return (
		<ul className="list-group list-group-flush mb-0">
			{items.map((item, index) => (
				<li key={index} className="list-group-item d-flex justify-content-between align-items-center px-2 no-hover">
					<span>{item.value}</span>

					{/* <RenderPart key={index} item={item} /> */}
				</li>
			))}
		</ul>
	);
};

export default List;